const baseDialogStyles = {
  '& p:nth-of-type(1)': {
    marginTop: 0
  }
}

export default {
  baseDialog: {
    ...baseDialogStyles
  },
  aboutDialog: {
    ...baseDialogStyles,
    lineHeight: 1.8,
    padding: 35
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/dialog.js